import { Component, OnInit, ViewChild } from '@angular/core';
import { APP } from 'src/app/app.config';
import { HttpClient } from '@angular/common/http';
import { stringify } from '@angular/compiler/src/util';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/user.service';
import jwt_decode from 'jwt-decode';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
  ) {}
  @ViewChild('focusthis') focusInput;
  email;
  password;
  isLoading;
  first = false;
  errortext = '';
  lastOrganisationSlug: string | null = null;
  lastOrganisationUrl: string | null = null;

  ngOnInit(): void {
    // Load last used organisation from local storage
    this.loadLastOrganisation();

    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;
    const extra = this.route.snapshot.paramMap.get('status');
    this.errortext = extra;

    //if (user && user.token) {
    if (this.userService.isAuthenticated) {
      console.log("user is authenticated with Cidaas");
      this.router.navigate(['administration']);
    } 
    else {
      let token = null;

      token = this.route.snapshot.paramMap.get('access_token');
      this.route.queryParams.subscribe((params) => {
        token = params.access_token;
      });

      if (token != null) {
        console.log("token is present");
        var decoded = jwt_decode(token);

        const user = {
          // @ts-ignore
          username: decoded.email,
          // @ts-ignore
          token,
        };

        this.saveToLocalStorage(user);
        console.log("logged in save user to ls and notify")
        console.log(user)
        this.userService.notify(user);
        this.router.navigate(['/administration']);
      } 
      else {
        // Use Cidaas SDK for browser-based login
        console.log("loginWithBrowser() removed here")
/*         this.userService.loginWithBrowser()
          .catch(error => {
            console.error("Login error:", error);
            // Fallback to the old method if SDK login fails
            // The cidaas URL already contains the redirect_uri parameter
            window.location.href = APP.cidaas;
          }); */
      }
    }
  }

  loadLastOrganisation(): void {
    let organisationSlug = localStorage.getItem('os');
    if (organisationSlug) {
      // Remove surrounding quotes if present (in case value is stored as JSON string)
      organisationSlug = organisationSlug.replace(/^["']|["']$/g, '');
      this.lastOrganisationSlug = organisationSlug;
      this.lastOrganisationUrl = `${window.location.origin}/o/${organisationSlug}`;
    }
  }

  loginWithBrowser() {
  // Use Cidaas SDK for browser-based login
    console.log("loginWithBrowser() after button click")
    this.userService.loginWithBrowser()
      .then((data) => {
        // Login Success

        this.isLoading = false;
        const user = {
          username: this.email,
          // @ts-ignore
          token: data.access_token,
        };

        this.saveToLocalStorage(user);
        this.userService.notify(user);
        this.router.navigate(['/administration']);
      })
      .catch(error => {
        console.error("Login error:", error);
        // Fallback to the old method if SDK login fails
        // The cidaas URL already contains the redirect_uri parameter
        window.location.href = APP.cidaas;
      });

  }


  login() {
    this.errortext = null;
    this.isLoading = true;
    this.userService
      .login(this.email, this.password)
      .then((data) => {
        // Login Success

        this.isLoading = false;
        const user = {
          username: this.email,
          // @ts-ignore
          token: data.access_token,
        };

        this.saveToLocalStorage(user);
        this.userService.notify(user);
        this.router.navigate(['/administration']);
      })
      .catch((error) => {
        // Login Fail
        this.errortext = 'You have entered an invalid username or password.';
        this.isLoading = false;
      });
  }

  saveToLocalStorage(user) {
    if (localStorage.getItem('user')) {
      const olduser = JSON.parse(localStorage.getItem('user'));

      olduser.username = user.username;
      olduser.token = user.token;

      localStorage.setItem('user', JSON.stringify(olduser));
    } else {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }
}
